import { render, staticRenderFns } from "./ListProgram.vue?vue&type=template&id=a952c560&scoped=true"
import script from "./ListProgram.vue?vue&type=script&lang=js"
export * from "./ListProgram.vue?vue&type=script&lang=js"
import style0 from "./ListProgram.vue?vue&type=style&index=0&id=a952c560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a952c560",
  null
  
)

export default component.exports